import { Select, SelectProps } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useSectionCourseDetail } from '@/store';

type Props = {
  courseId?: string;
  value?: string[] | string;
  placeholder?: string;
  mode?: 'multiple' | 'tags';
  allowClear?: boolean;
  disabled?: boolean;
  style?: SelectProps['style'];
  onChange?: (value: string[] | string) => void;
};

export const SectionSearchSelector: React.FC<Props> = ({
  courseId,
  value,
  placeholder,
  mode,
  style,
  allowClear = false,
  disabled = false,
  onChange
}) => {
  const { t } = useTranslation();
  const { course } = useSectionCourseDetail(courseId);
  const { sections } = course ?? {};

  const options = useMemo(
    () =>
      sections?.map(section => ({
        label: section.name,
        value: section._id
      })),
    [courseId, course]
  );

  const isDisabled = useMemo(() => !courseId, [courseId]);

  return (
    <Select
      disabled={disabled ?? isDisabled}
      showSearch
      style={style}
      options={options}
      value={value}
      placeholder={placeholder ?? t('SELECT_SECTION')}
      mode={mode}
      allowClear={allowClear}
      onChange={onChange}
      filterOption={(input, option) =>
        (option?.label.toLocaleLowerCase() ?? '').includes(input.toLocaleLowerCase())
      }
    />
  );
};
